import { useAct } from 'FlowBuilder/store'
import InlineCkEditor from 'Shared/components/CKEditor/InlineCkEditor'

export default function SettingsForm({ actionId }) {
    const act = useAct()
    const [userInstructionsSourceMode, setUserInstructionsSourceMode] = useState(false)
    const hasActiveActionTemplates = useSel(s => _.values(s.actionTemplates.entities).filter(at => at.actionId === actionId && at.active).length > 0)
    const mergeTags = useSel(s => s.builder.mergeTags)
    const action = useSel(s => s.actions.entities[s.local.selectedActionId])
    const config = action.config || { decisionMakerSetId: '', emailSenderId: '' }
    const decisionMakersSet = useSel(s => s.decisionMakersSet)

    function update(data) {
        act.actions.upsert(actionId, { config: { ...config, ...data } })
    }

    useEffect(() => {
        if (decisionMakersSet?.dataCollectionRequired !== null) {
            update({ requiredUserInfo: decisionMakersSet?.dataCollectionRequired })
        }
    }, [decisionMakersSet?.dataCollectionRequired])

    return <div>
        {decisionMakersSet?.dataCollectionRequired !== null &&
        <div className='field'>
            <label className="bold">No recipients found message</label>
            <input
                className="margin-top half full-width"
                type="text"
                value={config.noDecisionMakersFoundMessage ?? "Sorry, we've not got anyone for you to email."}
                onChange={e => update({ noDecisionMakersFoundMessage: e.target.value })}
            />
        </div>
        }
        <h3 className='margin-top double'>Email content settings</h3>
        <div className='flex field'>
            <label className="bold">Allow supporters to edit subject lines</label>
            <input
                className="margin-left"
                type="checkbox"
                checked={config.editableSubject}
                onChange={e => update({ editableSubject: e.target.checked })}
            />
        </div>
        <div className='flex field margin-top'>
            <label className="bold">Allow supporters to edit template</label>
            <input
                className="margin-left"
                type="checkbox"
                checked={!config.editableBody === false}
                onChange={e => update({ editableBody: e.target.checked, requireBodyEditing: false })}
            />
        </div>
        {!hasActiveActionTemplates && config.editableBody === false && <p className='error margin-top half'>Allow supporters to edit template must be enabled if no pre-written templates are provided.</p>}
        <div className='flex field margin-top'>
            <label className="bold">Require supporters to edit template</label>
            <input
                className="margin-left"
                type="checkbox"
                checked={config.requireBodyEditing}
                onChange={e => update({ requireBodyEditing: e.target.checked, editableBody: true })}
            />
        </div>

        <h3 className='margin-top double'>What supporter information should be sent to the recipient?</h3>
        <p>Everyone sending an email will be required to complete these fields. These will be included in the emails sent.</p>
        <div className='flex field column'>
            <div>
                {[
                    { value: 'name_email', label: 'Name and Email only' },
                    { value: 'name_email_postcode_address', label: 'Name, Email, Postcode and Address' },
                ].map(option => (
                    <div key={option.value}>
                        <label className="flex margin-top" style={{ gap: '5px' }}>
                            <input
                                type="radio"
                                name="requiredUserInfo"
                                value={option.value}
                                checked={config.requiredUserInfo === option.value}
                                onChange={e => update({ requiredUserInfo: e.target.value })}
                                disabled={decisionMakersSet?.dataCollectionRequired !== null}
                            />
                            {option.label}
                        </label>
                    </div>
                ))}
            </div>
        </div>

        <h2 className='margin-top double'>Instructions</h2>
        <p>You can optionally provide instructions or tips to supporters while they provide their details.</p>
        <div className='field flex margin-top'>
            <label className="bold">Show instructions</label>
            <input
                className="margin-left"
                type="checkbox"
                checked={config.includeUserInstructions}
                onChange={e => update({ includeUserInstructions: e.target.checked })}
            />
        </div>
        <div className='field margin-top half'>
            <InlineCkEditor
                value={config.userInstructionsContent}
                sourceMode={userInstructionsSourceMode}
                setSourceMode={setUserInstructionsSourceMode}
                onUpdate={value => update({ userInstructionsContent: value })}
                mergeTags={mergeTags}
                disabled={!config.includeUserInstructions}
            />
        </div>
    </div>
}
